// Promise-dedup helper. Mirrors backend's cached() pattern: concurrent
// callers asking for the same key get the same in-flight promise.
// Cleared on settle so the next call refetches.
//
// Entries carry a timestamp so evictStale() can drop promises that will
// never settle (socket killed by laptop sleep — see
// PERF-CACHE-RESILIENCE-SPEC.md Phase 1c). Without eviction, a dead
// promise wedges every subsequent refresh for its key until hard refresh.

const inFlight = new Map();

export function inFlightDedup(key, fn) {
  const entry = inFlight.get(key);
  if (entry) return entry.promise;
  const promise = Promise.resolve()
    .then(fn)
    .finally(() => {
      // Guard: if this entry was evicted and a newer promise now owns the
      // key, settling must not delete the newer entry.
      if (inFlight.get(key)?.promise === promise) inFlight.delete(key);
    });
  inFlight.set(key, { promise, ts: Date.now() });
  return promise;
}

// Default 95s > the 90s pipeline timeout in api.js, so a healthy slow
// request is never evicted while still viable.
export function evictStale(maxAgeMs = 95_000) {
  const now = Date.now();
  for (const [key, entry] of inFlight) {
    if (now - entry.ts > maxAgeMs) inFlight.delete(key);
  }
}
